import { useState } from 'react';
import { DateType } from 'ui/datePicker';

interface DateRange {
  startDate: string;
  endDate: string;
}
export const useDateRangePicker = (initialDateRange: DateRange) => {
  const [dateRange, setDateRange] = useState<DateRange>({
    startDate: initialDateRange.startDate,
    endDate: initialDateRange.endDate,
  });

  const handleDateChange = ({
    startDate,
    endDate,
  }: {
    startDate: DateType;
    endDate: DateType;
  }) => {
    if (!startDate || !endDate) return;
    setDateRange({ startDate: startDate.toISOString(), endDate: endDate.toISOString() });
  };

  const handleCancel = () => {
    setDateRange({
      startDate: initialDateRange.startDate,
      endDate: initialDateRange.endDate,
    });
  };
  return { dateRange, handleDateChange, handleCancel };
};
